<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">تجهیزات مورد نیاز</h4>
    </div>
    <div class="card-body">
      <div class="row mb-3 align-items-end">
        <div class="col-md-9">
          <label class="form-label fw-bold">ابزار</label>
          <input
              type="text"
              class="form-control"
              placeholder="ابزار مورد نظر را وارد کنید"
              v-model="newEquipment.name"
          />
        </div>
        <div class="col-md-3">
          <GeneralButton @clicked="addEquipment"/>
        </div>
      </div>
      <hr class="my-3">

      <!-- Equipments Table -->
      <GeneralTable
          :headers="['تجهیز']"
          :fields="['name']"
          :items="jobQualification.equipments"
          :openEditModalMethod="openEditModal"
          @remove="removeEquipment"
      />

      <!-- Edit Equipment Modal -->
      <GeneralModal
          v-show="editedEquipment"
          title="ویرایش تجهیز"
          modal-id="equipmentModalId"
          @save="updateEquipment"
      >
        <div class="row mb-3">
          <div class="col-md-12">
            <label class="form-label fw-bold">تجهیز</label>
            <input
                type="text"
                class="form-control"
                placeholder="تجهیز را وارد کنید"
                v-if="editedEquipment"
                v-model="editedEquipment.name"
            />
          </div>
        </div>
      </GeneralModal>
    </div>
  </div>
</template>

<script>
import GeneralTable from "@/components/JobDescription/GeneralComponents/GeneralTable.vue";
import GeneralModal from "@/components/JobDescription/GeneralComponents/GeneralModal.vue";
import {Modal} from "bootstrap";
import {useToast} from "vue-toastification";
import GeneralButton from "@/components/JobDescription/GeneralComponents/GeneralButton.vue";

const baseStructure = {
  name: ""
}
const toast = useToast();

export default {
  components: {GeneralButton, GeneralTable, GeneralModal},
  data() {
    return {
      newEquipment: structuredClone(baseStructure),
      editedEquipment: null,
      editIndex: null,
    };
  },
  computed: {
    jobQualification: {
      get() {
        return this.$store.state.jobQualification.jobQualification;
      },
    },
  },
  methods: {
    async addEquipment() {
      if (!this.newEquipment.name) {
        toast.error("نام تجهیز را وارد کنید!");
        return;
      }

      const response = await this.$store.dispatch("crudActions/create", {
        resourceData: this.newEquipment,
        endpoint: "/job-qualifications/store-equipment",
      });

      this.jobQualification.equipments = [...this.jobQualification.equipments, structuredClone(response.data),];
      this.newEquipment = structuredClone(baseStructure);
    },
    removeEquipment(index) {
      const equipment = this.jobQualification.equipments.find((_, i) => i === index);
      this.jobQualification.equipments = this.jobQualification.equipments.filter(
          (_, i) => i !== index
      );

      this.$store.dispatch("crudActions/delete", {
        resourceId: equipment.id,
        endpoint: "/job-qualifications/delete-equipment",
      });
    },
    openEditModal(equipment, index) {
      this.editedEquipment = structuredClone(equipment);
      this.editIndex = index;
      const modal = Modal.getOrCreateInstance(document.getElementById("equipmentModalId"));
      modal.show();
    },
    updateEquipment() {
      if (this.editIndex === null) {
        return;
      }

      if (!this.editedEquipment.name) {
        toast.error("نام تجهیز را وارد کنید!");
        return;
      }

      this.jobQualification.equipments.splice(this.editIndex, 1, {
        ...this.editedEquipment,
      });

      this.$store.dispatch("crudActions/update", {
        resourceData: this.editedEquipment,
        endpoint: "/job-qualifications/update-equipment",
      });

      this.editIndex = null;
      this.editedEquipment = null;
      const modal = Modal.getOrCreateInstance(document.getElementById("equipmentModalId"));
      modal.hide();
    },
  },
};
</script>
